import React from "react";
import { Input as AntdInput, InputProps } from "antd";
import { TextAreaProps, PasswordProps } from "antd/es/input";

/**
 * Custom Input component that stops event propagation for keydown events.
 * This prevents parent components (like Drawers or Modals) from intercepting
 * arrow keys, which are needed for cursor navigation within the input.
 */
const Input = (props: InputProps) => {
  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    e.stopPropagation();
    if (props.onKeyDown) {
      props.onKeyDown(e);
    }
  };

  return <AntdInput {...props} onKeyDown={handleKeyDown} />;
};

// Add support for TextArea
Input.TextArea = (props: TextAreaProps) => {
  const handleKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    e.stopPropagation();
    if (props.onKeyDown) {
      props.onKeyDown(e);
    }
  };

  return <AntdInput.TextArea {...props} onKeyDown={handleKeyDown} />;
};

// Add support for Password
Input.Password = (props: PasswordProps) => {
  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    e.stopPropagation();
    if (props.onKeyDown) {
      props.onKeyDown(e);
    }
  };

  return <AntdInput.Password {...props} onKeyDown={handleKeyDown} />;
};

// Add support for Search
Input.Search = (props: any) => {
  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    e.stopPropagation();
    if (props.onKeyDown) {
      props.onKeyDown(e);
    }
  };

  return <AntdInput.Search {...props} onKeyDown={handleKeyDown} />;
};

export default Input;
